<template>
  <div class="edit-active-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      height="100%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="110px"
        label-position="left"
      >
        <div class="form-flex-box">
          <el-form-item label="游戏封面:" prop="cover">
            <base-upload
              class="upload"
              :cover="params.cover"
              :action="action"
              :hide="true"
              @successCallback="successImageCover"
            ></base-upload>
          </el-form-item>
          <el-form-item label="游戏背景:" prop="bgCover">
            <base-upload
              class="upload"
              :cover="params.bgCover"
              :action="action"
              :hide="true"
              @successCallback="successImageBgCover"
            ></base-upload>
          </el-form-item>
        </div>
        <el-form-item label="游戏截屏:" prop="gameScreenshots" v-if="isShow">
          <!-- <base-upload
              class="upload"
              :cover="params.gameScreenshots"
              :action="action"
              :hide="true"
              @successCallback="successImagegameScreenshots"
            ></base-upload> -->
          <imgs-upload
            :cover="params.gameScreenshots"
            :action="actionPics"
            @successCallback="successCallbackPic"
            :id="params.sourceID"
            :wSize="180"
            :hSize="320"
            :width="'100px'"
            :height="'100px'"
            ref="uploadImgs"
          ></imgs-upload>
        </el-form-item>
        <div class="form-flex-box">
          <el-form-item label="游戏名称:" prop="name">
            <el-input
              v-model="params.name"
              size="small"
              placeholder="请输入游戏名称"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="密码:" prop="password">
            <el-input
              v-model="params.password"
              size="small"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="游戏价格:" prop="coin">
            <el-input
              v-model.number="params.coin"
              size="small"
              placeholder="请输入游戏价格"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="游戏链接:" prop="url">
            <el-input
              v-model="params.url"
              size="small"
              placeholder="请输入游戏链接"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="游戏类型:" prop="gameType">
          <el-select
            v-model="params.gameType"
            size="small"
            placeholder="请选择状态"
            style="width:100%"
          >
            <el-option
              v-for="item in gameTypes"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏排序:" prop="sort">
          <el-input
            v-model.number="params.sort"
            size="small"
            placeholder="请输入游戏排序"
          ></el-input>
        </el-form-item>
        <el-form-item label="游戏详情:" prop="detail">
          <el-input
            v-model.trim="params.detail"
            type="textarea"
            size="small"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入游戏详情"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      // 图片上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      actionPics: baseConfig.baseServerUrl + "/vid/uploadStaticBatch",
      dialogVisible: false,
      title: "新增游戏",
      flag: false,
      type: "", //表单类型
      isShow: true,
      params: {
        name: "",
        detail: "",
        coin: undefined,
        password: "",
        gameType: "",
        id: undefined,
        sort: undefined,
        cover: "",
        bgCover: "",
        gameScreenshots: [],
        url: "",
      },
      gameTypes: [
        {
          label: "pc",
          value: "pc",
        },
        {
          label: "android",
          value: "android",
        },
      ],
      // 表单验证规则
      rules: {
        gameType: [
          { required: true, message: "请选择游戏类型", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入游戏名称", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        url: [{ required: true, message: "请输入游戏链接", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 封面图上传成功回调
    successImageCover(cover) {
      this.params.cover = cover.data.coverImg;
    },
    successImageBgCover(cover) {
      this.params.bgCover = cover.data.coverImg;
    },
    successCallbackPic(seriesCover) {
      this.params.gameScreenshots = seriesCover;
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "edit") {
            this.modifyGame();
          }
          if (this.type == "add") {
            this.addGame();
          }
        } else {
          return false;
        }
      });
    },
    // 新增游戏
    addGame() {
      let params = Object.assign({}, this.params);
      API.addGame(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$emit("handlerList");
          } else {
            this.$message.error(res.msg || "新增失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑活动
    modifyGame() {
      let params = Object.assign({}, this.params);
      API.modifyGame(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.isShow = false;
      this.params = {
        name: "",
        detail: "",
        gameType: "",
        password: "",
        sort: undefined,
        id: undefined,
        coin: undefined,
        cover: "",
        bgCover: "",
        gameScreenshots: [],
        url: "",
      };
    },

    // 打开编辑游戏弹窗、传递需要编辑的参数
    open(type, data) {
      this.isShow = true;
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "编辑游戏";
        this.params = Object.assign({}, data);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-active-box {

}
</style>
